<template>
    <flex-container
        justify-content="space-between"
        align-items="center"
        no-wrap
    >
        <span style="word-break: break-word;">
            <slot>
                {{ props.value }}
            </slot>
        </span>
        <button-plain-icon
            :icon="CopyIcon"
            :size="IconSize.xs"
            color="gray-500"
            is-custom-icon
            @click="copyToClipboard"
        />
    </flex-container>
</template>

<script setup lang="ts">
    import CopyIcon from '@keyvue/one-awesome-icons/icons/regular/copy.svg?component';
    import useClipboard from '@/shared/composables/useClipboard';
    import { IconSize, NotificationBlock, useNotify } from '@keyvue/one-ui';

    const props = defineProps<{
        value: string
    }>();

    const clipboard = useClipboard();
    const { notify } = useNotify();

    function copyToClipboard(): void {
        clipboard.writeText(props.value);
        notify({
            component: NotificationBlock,
            props: {
                color: 'green-500',
                title: 'Gekopieerd!',
                text: `"${props.value}" is gekopieerd!`,
                icon: CopyIcon,
                isCustomIcon: true,
            },
            duration: 3000,
        });
    }
</script>
